import { all, takeLatest, fork, put, select } from 'redux-saga/effects';
import SettingsApi from 'libs/api/settings';
import routeCodes from 'common/constants/route-codes';

import * as types from './types';
import UIHelper from '../../services/UIHelper';

function* getSettings() {
  try {
    const currentRestaurant = yield select(
      (state) => state.common.currentRestaurant,
    );
    const api = new SettingsApi(currentRestaurant?.id);
    const { data } = yield api.list();
    yield put({
      type: types.SETTINGS_GET_SUCCESS,
      payload: data,
    });
    history.push(routeCodes.home);
  } catch (e) {
    yield put({
      type: types.SETTINGS_GET_FAILURE,
      payload: e?.response?.data,
    });
  }
}

function* updateRequest({ payload }) {
  try {
    const currentRestaurant = yield select(
      (state) => state.common.currentRestaurant,
    );
    const api = new SettingsApi(currentRestaurant?.id);
    const { history, data: formData } = payload;
    const { data } = yield api.put(null, { data: formData });
    yield put({
      type: types.SETTINGS_UPDATE_SUCCESS,
      payload: data,
    });
    UIHelper.successNotification('Impostazioni state salvata con successo');
    // history?.push(routeCodes.settings);
  } catch (e) {
    yield put({
      type: types.SETTINGS_UPDATE_FAILURE,
      payload: e?.response?.data,
    });
  }
}

function* watchSettingsGetRequest() {
  yield takeLatest(types.SETTINGS_GET_REQUEST, getSettings);
}
function* watchSettingsUpdateRequest() {
  yield takeLatest(types.SETTINGS_UPDATE_REQUEST, updateRequest);
}

export default function* settingsSagas() {
  yield all([fork(watchSettingsGetRequest), fork(watchSettingsUpdateRequest)]);
}
